//Top segment of the app; includes information about the current session
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import AbEnvironment from './auth/AbEnvironment';
import EnvironmentDefs from '../EnvironmentDefs';
import { AppBar, Typography } from '@mui/material';

import UserInfoAvatar from './auth/UserInfoAvatar';
import AppBarCustLandingLogo from './AppBarCustLandingLogo';
import smartlookClient from 'smartlook-client'; 

const abEnvironment = new AbEnvironment();
const envDefs = new EnvironmentDefs();

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: 100,
    /* backgroundColor: transparent */
    backgroundColor: '#fcfcfc',
    borderBottom: 'solid 1px #eee',
    top: 0,
    padding: 0,
    height: 50,
    // display: 'flex',
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: 5,
    marginRight: 5,
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  toolBarItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoContainer: {
    position: 'absolute',
    left: '60px',
    top: '8px'
  },
  masqueradeTitleOpen: {
    position: 'absolute',
    left: '208px',
    top: '14px'
  },  
  masqueradeTitleClosed: {
    position: 'absolute',
    left: '64px',
    top: '14px'
  },  
  avatar:  {
    position: 'absolute',
    right: '0px',
    top: '8px'
  },
});

class App extends Component {
  button = null;

  componentDidMount() {
    //Get the smarklook key and initialize.
    let key = envDefs.getSmartlookKey();
    if (key) { 
      //console.log('initializing smartlook with key='  + key);
      try {
        smartlookClient.init(key);
      } catch (error) {
        console.log('Error trying to initialize smartlook');
      }
    } else {
      //console.log('not initializing smartlook.  check REACT_APP_SMARTLOOK in .env. ');
    }
  }

  componentDidUpdate(prevProps) {
    //if the route location changed, signal user pilot in case it needs to do something....
    const { location: { pathname } } = this.props;
    const previousLocation = prevProps.location.pathname;
    if (pathname !== previousLocation) {
      try {
        if (window.userpilot) {
          window.userpilot.reload();
        }
   
      } catch (error) {
        this.props.auth.logError('User pilot navigation error: ' + error);
      }
    }
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  /*
  login() {
    this.props.auth.login();
  }
  */

  logout() {
    this.props.auth.logout();
  }

  endMasquerade() {
    this.props.auth.endMasquerade();
  }

  handleMenuClick = () => {
    this.props.routes.navdrawer.toggleDrawer();
  }

  render() {
    const { isMasquerade, isAuthenticated, isAuthenticatedCustomer, isUnauthenticatedCustomer, isAuthenticatedVendor, isAuthenticatedReseller, isAuthenticatedAppBind } = this.props.auth;
    const classes = this.props.classes;

    // Ignore if on the partner route
    if (   this.props.location.pathname.startsWith('/partner') 
        || this.props.location.pathname.startsWith('/order')
        || this.props.location.pathname.startsWith('/stepper') )
    {
      return (null);
    }

    let accountName = '';
    let accountType = '';
    if (isMasquerade()) {
      accountName = abEnvironment.getUserAttribute('a_accountName');
      let atype = abEnvironment.getUserAttribute('a_aType');
      if (atype === "1") {
        accountType = "Vendor";
      } else if (atype === "2") {
        accountType = "Distributor";
      } else if (atype === "3") {
        accountType = "Reseller";
      } else if (atype === "4") {
        accountType = "Customer";
      }
    }

    var onCustomerStepper = false;
    if (this.props.location.pathname.startsWith('/stepperresumecustomer'))  {
      onCustomerStepper = true;
    }
    if (this.props.location.pathname.startsWith('/authonlyauthorize')) {
      onCustomerStepper = true;
    }

    return (

      <div id="appBar" className={classes.root}>
        <AppBar elevation={0} className={classes.appBar}>
          {!isUnauthenticatedCustomer() && !isMasquerade() &&
          <div className={classes.logoContainer}>
            <img alt="AppBind Logo" height="30px" src={'/logos/appbind-logo-c-b.png'} />
          </div>}

          {!isUnauthenticatedCustomer() && isAuthenticated() && isMasquerade() && this.props.routes.state.open &&
          <div className={classes.masqueradeTitleOpen}>
            <Typography variant="subtitle1" style={{color: 'black'}}>
              Masquerading as {accountName} ({accountType})
            </Typography>
          </div>}

          {!isUnauthenticatedCustomer() && isAuthenticated() && isMasquerade() && !this.props.routes.state.open &&
          <div className={classes.masqueradeTitleClosed}>
            <Typography variant="subtitle1" style={{color: 'black'}}>
              Masquerading as {accountName} ({accountType})
            </Typography>
          </div>}

          {isUnauthenticatedCustomer() && (onCustomerStepper === false) &&
          <AppBarCustLandingLogo auth={this.props.auth} menuOpen={this.props.routes.state.open} isMasquerade={isMasquerade()}/>}
          
          {isUnauthenticatedCustomer() &&
          <div className={classes.avatar}>
            <UserInfoAvatar
              uname={abEnvironment.getUserAttribute("userName")}
              auth={this.props.auth}
              history={this.props.history}
              logout={this.logout}
              endMasquerade={this.endMasquerade}
              goTo={this.goTo}
              unAuthenticatedCustomer={true}
              onCustomerStepper={onCustomerStepper}
            />
          </div>}            

          { (isAuthenticatedReseller() || isAuthenticatedVendor() || isAuthenticatedAppBind() || isAuthenticatedCustomer()) &&
          <div className={classes.avatar}>
            <UserInfoAvatar
              uname={abEnvironment.getUserAttribute("userName")}
              auth={this.props.auth}
              history={this.props.history}
              logout={this.logout}
              endMasquerade={this.endMasquerade}
              goTo={this.goTo}
              unAuthenticatedCustomer={false}
              onCustomerStepper={onCustomerStepper}
            />
          </div>}

        </AppBar>
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(App);